/**
 * Defines Airtable Table names and IDs for easier handling
 */
enum AirtableTableId {
  Pages = "tblc3tYE6DYtUNnVQ",
  Collections = "tbl68wML9cjMrq9i7",
  Assets = "tblswZwsVAPFnXq1c",
}

/**
 * Defines Platform variations for Airtable Pages
 */
enum AirtablePagePlatform {
  Mobile = "Mobile",
  TV = "TV",
  Web = "Web",
}

/**
 * Defines Rail Type variations for Airtable Collections
 */
enum AirtableCollectionRailType {
  Showcase = "Showcase",
  Spotlight = "Spotlight",
  Standard = "Standard",
  TopTen = "Top 10",
}

/**
 * Defines Airtable response for a single Page
 */
interface AirtablePageResponse {
  Name: string | undefined;
  Platform: AirtablePagePlatform | undefined;
  Collections: string[] | undefined;
}

/**
 * Defines Airtable response for a single Collection
 */
interface AirtableCollectionResponse {
  Name: string | undefined;
  Pages: string[] | undefined;
  Assets: string[] | undefined;
  "Asset Slugs": string[] | undefined;
  "Show Metadata": Boolean | undefined;
  "Rail Type": AirtableCollectionRailType | undefined;
}

/**
 * Defines Airtable response for a single Asset
 */
interface AirtableAssetResponse {
  Name: string | undefined;
  "Atom ID": string | undefined;
  "Atom Slug": string | undefined;
  "Atom UUID": string | undefined;
}

/**
 * Defines generic Airtable response for a single record (not table-specific)
 */
interface AirtableRecordResponse {
  id: string;
  createdTime: string;
  fields:
    | AirtablePageResponse
    | AirtableCollectionResponse
    | AirtableAssetResponse;
}

/**
 * Defines generic Airtable response that returns all assets within a given Airtable table
 */
interface AirtableTableResponse {
  records: [AirtableRecordResponse];
}

export { AirtableTableId, AirtablePagePlatform, AirtableCollectionRailType };
export type {
  AirtablePageResponse,
  AirtableCollectionResponse,
  AirtableAssetResponse,
  AirtableRecordResponse,
  AirtableTableResponse,
};
